import phone from '../Img/Bot/Choice/phone.png'
import ru from '../Img/Bot/Choice/ru.png'
import call from '../Img/Bot/Choice/call.png'
import robo from '../Img/Bot/Choice/robo.png'
import sms from '../Img/Bot/Choice/sms.png'
import net from '../Img/Bot/Choice/net.png'

import mnp from '../Img/Bot/Choice/mnp.png'

import cpBack from '../Img/Bot/Choice/coupon-back.png'
import copyImg from '../Img/Bot/Choice/copy.png'

import lpBeeline from '../Img/Card/logoBeeline.png'
import lpMegafon from '../Img/Card/logoMegafon.png'
import lpTele2 from '../Img/Card/logoTele2.png'
import lpYota from '../Img/Card/logoYota.png'

import copy from 'copy-to-clipboard';

import st0Wallet from '../Img/Bot/Choice/stWallet.png'
import st0Location from '../Img/Bot/Choice/stLocation.png'
import st0Sim from '../Img/Bot/Choice/stSim.png'

import findBack from '../Img/Bot/Choice/find-phone.png'


import cdNet from '../Img/Bot/Choice/cdNet.png'
import cdPacket from '../Img/Bot/Choice/cdPacket.png'


import titleRobo from '../Img/Bot/Choice/titleRobo.png'
import styles from './ChoiceBot.module.css'
import {useEffect, useRef, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import useApiQuery from "../ApiQuery/UseApiQuery";

interface ICardLineItem
{
    val:string
    regionId:number
}
interface ICardResponse
{
    list: ICardItem[]
    couponId: string
}



interface ICardItem {
    apList: ICardLineItem[]
    netList:ICardLineItem[]
    packetList:ICardLineItem[]
    operOne:{
        name:string
    }
    operId:string
    smsCount?:number
    name:string
    needMnp?:boolean

}



interface IBlockInput
{
    bigTitle:string
    title:string
    placeHolder?:string
    maxLen?:number
    inputMode?:"text"|"numeric"
    logo?:string

    val:string
    onChange?:(x:string)=>void
    onBlur?:(x:string)=>void

    cssBlink?:string



}

declare global {
    interface Window {
        WebApp: any;
    }
}

interface ITarifListRequest
{
    ctn: string
    ap:number
    packet:number
    net:number
    unlimNet:boolean
    overPacket:boolean
    userId?:number
    referer?:string
}

interface IUserInfo
{
    userId:number
    referer?:string
}
export default function ChoiceBot(){

    const [step, setStep] = useState(0)

    const [shDetail, setShDetail] = useState(-1)
    const shDetailTimer = useRef<NodeJS.Timer>()

    const [userInfo, setUserInfo] = useState<IUserInfo>()

    const refCoupon = useRef<HTMLDivElement>(null)
    const [initData, setInitData]= useState("start")
    const navigate = useNavigate()
    const [link, setLink] = useState("https://sim-unlim.com")

    const cardListData = useRef<ITarifListRequest>()
    const [ldrCardList,rsCardList,exCardList] = useApiQuery("/bot/choice/tarif/list","post",cardListData);

    const [cardList, setCardList] = useState<ICardItem[]>([])


    const [percent, setPercent] = useState(-1)

    const [couponId, setCouponId] = useState("ПАТРИОТ")


    const [cnt, setCnt] = useState(0)


    const [unlim, setUnlim] = useState(false)
    const [outPacket, setOutPacket] = useState(false)

    const [ctn , setCtn] = useState("")
    const [ctnText , setCtnText] = useState("")
    const [invalidCtn, setInvalidCtn] = useState(false)


    const [cost , setCost] = useState(-1)
    const [costText , setCostText] = useState("")
    const [invalidCost, setInvalidCost] = useState(false)


    const [minute , setMinute] = useState(-1)
    const [minuteText , setMinuteText] = useState("")
    const [invalidMin, setInvalidMin] = useState(false)


    const [gb , setGb] = useState(-1)
    const [gbText , setGbText] = useState("")
    const [invalidNet, setInvalidNet] = useState(false)


    const [shCopyBuffer, setShCopyBuffer] = useState(false)

    useEffect(()=>{
        if(shDetail >=0 ){
            clearTimeout(shDetailTimer.current)
            shDetailTimer.current  = setTimeout(()=>setShDetail(-1), 5000)

        }
    },[shDetail])

    useEffect(()=>{
        const initData = window.WebApp.initData
        console.log(`max init data ${initData}`)
        setInitData(initData ? initData : "no")
        // Парсим данные пользователя
        const x = maxParseInitData(initData);

        if(x?.user?.id) {
            setUserInfo({
                userId:x?.user?.id,
                referer: x?.start_param ? x?.start_param : undefined
            })
            return
        }

    },[])


    useEffect(()=>{
        console.log("percent", percent)
        if(percent >= 0){
            if(percent > 100) setPercent(0)
            setTimeout(()=>{
                if(step === 15)setPercent(prevState => percent + 10)
                else setPercent(-1)
            }, 300)
        }

    },[percent])


    useEffect(()=>{
        setPercent(-1)
        if(step === 0){
            if(cnt > 10) return
            setTimeout(()=>{
                setCnt(prevState => cnt + 1)
            }, 800)
        }


    },[step, cnt])

    useEffect(()=>{
    }, [cnt])



    useEffect(()=>{
        if(unlim){
            setGb(9999)
            setGbText("безлимит")
            return
        }
        setGbText("")
        setGb(-1)

    },[unlim])



    async function copyCoupon(showTip:boolean = true) {
        try {
            if(showTip){
                setShCopyBuffer(true)
                setTimeout(()=>setShCopyBuffer(false), 1500)

            }
//            await navigator.clipboard.writeText(couponId);
            await copy(couponId)
            console.log('Текст успешно скопирован в буфер обмена');
        } catch (error) {
            console.error('Ошибка при копировании:', error);
        }
    }

    const handleFind = ()=>{
        if(ldrCardList) return
        if(! ctn?.match(/^[0-9]{10}$/ui)){
            setInvalidCtn(true)
            setTimeout(()=>setInvalidCtn(false), 2000)
            return
        }

        if(cost <=0){
            setInvalidCost(true)
            setTimeout(()=>setInvalidCost(false), 2000)
            return

        }
        if(minute <0){
            setInvalidMin(true)
            setTimeout(()=>setInvalidMin(false), 2000)
            return

        }

        if(! unlim && gb <0){
            setInvalidNet(true)
            setTimeout(()=>setInvalidNet(false), 2000)
            return

        }

        cardListData.current ={
            ctn: ctn,
            net: gb,
            ap: cost,
            overPacket: outPacket,
            packet: minute,
            unlimNet: unlim,
            userId: userInfo ? userInfo?.userId : undefined,
            referer: userInfo ? userInfo?.referer : undefined,
        }

        setPercent(0)
        setStep(15)

        exCardList().then((e)=>{
            if(e?.success){
                try {
                    setCardList(e?.payload?.list)
                    setCouponId(e?.payload?.couponId?.toUpperCase())
                    setLink(e?.payload?.link)
                    setTimeout(()=>setStep(20), 2000)
                    return

                } catch (e) {

                }
            }
        })

    }


    const maxParseInitData = (initData: string) => {
        const params = new URLSearchParams(initData);
        try {
            const  user = params.get('user')
            const chat = params.get('chat')
            const x = {
                user: JSON.parse(user ? user : "{}"),
                hash: params.get('hash'),
                auth_date: params.get('auth_date'),
                start_param: params.get('start_param'),
                chat: JSON.parse(chat ? chat : "{}"),
            }
            return x

        } catch (e)
        {}
        return  null
    };


    const buildInputLine = (data:IBlockInput)=>{

        return(
            <div className={styles.ibCont}>

                <div className={[styles.inBigTitle, data?.cssBlink ? data?.cssBlink : ""].join(' ')}>{data?.bigTitle}</div>
                <div className={styles.inLineBlock}>
                    <div className={styles.inBlockCont}>
                        <div className={[styles.inLineBlockTitle,].join(' ')}>{data?.title}</div>
                        <div className={styles.inBlockInput}><input
                            placeholder={data?.placeHolder}
                            maxLength={data?.maxLen}
                            inputMode={data?.inputMode}
                            value={data?.val}
                            onChange={(e)=>{
                                if(data?.onChange)data.onChange(e?.target?.value)
                            }}
                            onBlur={(e)=>{
                                if(data?.onBlur)data.onBlur(data?.val)
                            }}


                        /></div>
                    </div>
                    <div className={[styles.inBlockLogo,data?.cssBlink ? styles.shake : ""].join(' ')}>
                        {data?.logo &&
                            <img src={[data?.logo, ].join(' ')} alt={"телефон"}/>
                        }
                    </div>

                </div>

            </div>
        )

    }

    const checkBox = (val: boolean, setVal: (x:boolean)=>void)=>{
        return(
            <div
                onClick={()=>setVal(!val)}
            >
                <div className={[styles.slUnit, val ? styles.slUnitSelect : ""].join(' ')}>
                    <div className={[styles.slBall, val ? styles.slBallSelect : ""].join(' ')}></div>
                </div>

            </div>

        )
    }

    const buildNetLine = (data:IBlockInput)=>{

        return(
            <div className={styles.ibCont}>

                <div className={[styles.inBigTitle, data?.cssBlink ? data?.cssBlink : ""].join(' ')}>{data?.bigTitle}</div>

                <div className={styles.xBlock}>
                    <div className={styles.inLineBlock}>
                        <div className={styles.mBlock}>

                            <div className={styles.xlCont}>
                                <div className={styles.inBlockCont}>
                                    <div className={styles.inLineBlockTitle}>{data?.title}</div>
                                    <div className={styles.inBlockInput}><input
                                        placeholder={data?.placeHolder}
                                        maxLength={data?.maxLen}
                                        inputMode={data?.inputMode}
                                        disabled={unlim}
                                        value={data?.val}
                                        onChange={(e)=>{
                                            if(data?.onChange)data.onChange(e?.target?.value)
                                        }}
                                        onBlur={(e)=>{
                                            if(data?.onBlur)data.onBlur(data?.val)
                                        }}



                                    /></div>
                                </div>

                                <div className={[styles.inBlockLogo, data?.cssBlink ? styles.shake : ""].join(' ')}>
                                    {data?.logo &&
                                        <img src={data?.logo} alt={"телефон"}/>
                                    }
                                </div>

                            </div>
                            <div className={styles.unCont}>
                                <div className={styles.ntTitle}>У меня безлимитный интернет</div>
                                {checkBox(unlim, setUnlim)}
                            </div>


                        </div>



                    </div>


                </div>



            </div>
        )

    }

    const onChangeCtn= (val: string)=>{
        //console.log("valCtn", val)
        if(! val) {
            setCtn("")
            setCtnText("")
            return
        }
        const x = val?.replaceAll(/[^0-9]+/uig,'')
       // console.log("x",x)
        const rgCtn = x?.match(/9[0-9]{9}$/)
        if(rgCtn){
            const ctn = rgCtn[0]
            setCtn(ctn)
            const x = "+7 ("+ ctn?.substring(0,3) + ") " + ctn?.substring(3,6) + "-" + ctn?.substring(6,8) + "-" + ctn?.substring(8,10)
            setCtnText(x)
            return
        }
        setCtnText(val)

    }

    const onChangeCost = (val: string)=>{
        if(!val) {
            setCostText("")
            setCost(-1)
            return
        }

        const xp = val?.replace(/[^0-9]/ui,'')
        if(xp?.length === 0){
            setCostText("")
            setCost(-1)
            return
        }

        const x = Number(xp)
        if(isNaN(x)){
            setCostText(xp)
            setCost(-1)
            return
        }

        setCost(x)
        setCostText(xp)

    }
    const onChangeMinute = (val: string)=>{
        if(!val) {
            setMinuteText("")
            setMinute(-1)
            return
        }
        const xp = val?.replace(/[^0-9]/ui,'')
        if(xp?.length === 0){
            setMinuteText("")
            setMinute(-1)
            return
        }

        const x = Number(xp)
        if(isNaN(x)){
            setMinuteText(val)
            setMinute(-1)
            return
        }

        setMinuteText(xp)
        setMinute(x)

    }

    const onChangeGb = (val: string)=>{
        if(!val) {
            setGbText("")
            setGb(-1)
            return
        }

        const xp = val?.replace(/[^0-9]/ui,'')
        if(xp?.length === 0){
            setGbText("")
            setGb(-1)
            return
        }

        const x = Number(xp)
        if(isNaN(x)){
            setGbText(val)
            setGb(-1)
            return
        }

        setGbText(xp)
        setGb(x)

    }


    const buildStepInData = ()=>{
        return(
            <div className={styles.showSlow}>
                <div className={styles.rbCont}>
                    <div className={styles.rbImg}><img src={robo} alt={"Робот"}/></div>
                    <div className={styles.rbTextItem}>
                        <div className={styles.rbMainText}>Бот-подбор тарифа</div>
                        <div className={styles.rbSmallText}>Найдем тариф выгоднее текущего</div>
                        <div className={styles.rbSmallText}>Введите параметры Вашего тарифа</div>
                    </div>
                </div>



                {buildInputLine({
                    bigTitle: "Номер телефона",
                    title: "Номер телефона для сравнения",
                    placeHolder: "+7 (999) 604-00-00",
                    maxLen:18,
                    inputMode:"numeric",
                    logo: phone,
                    val:ctnText,
                    onChange: onChangeCtn,
                    cssBlink: invalidCtn ? styles.validBlink : undefined
                })}

                {buildInputLine({
                    title: "Сколько вы платите в месяц",
                    bigTitle: "Текущая стоимость",
                    logo: ru,
                    maxLen:4,
                    inputMode:"numeric",
                    placeHolder: "Например, 500",
                    val: costText,
                    onChange: onChangeCost,
                    cssBlink: invalidCost ? styles.validBlink : undefined


                })}

                {buildInputLine({
                    title: "Сколько у вас минут в пакете",
                    bigTitle: "Минуты",
                    logo: call,
                    maxLen:4,
                    inputMode:"numeric",
                    placeHolder: "Например, 400",
                    val: minuteText,
                    onChange: onChangeMinute,
                    cssBlink: invalidMin ? styles.validBlink : undefined




                })}


                {buildNetLine({
                    title: "Какой ваш объем пакета интернета",
                    bigTitle: "Интернет (Гб)",
                    logo: net,
                    maxLen:4,
                    inputMode:"numeric",
                    placeHolder: "Например, 30",
                    val: gbText,
                    onChange: onChangeGb,
                    cssBlink: invalidNet ? styles.validBlink : undefined


                })}


                <div className={styles.pkCont}>
                    <div className={styles.unCont}>
                        <div className={styles.pkTitle}>Мне не всегда хватает пакета трафика</div>
                        {checkBox(outPacket, setOutPacket)}
                    </div>

                </div>



                <div className={styles.btCont}>
                    <div className={[styles.btMain, ldrCardList ? styles.bcGray : ""].join(' ')}
                        onClick={()=>handleFind()}
                    >подобрать выгодный тариф</div>
                </div>
            </div>
        )
    }


    const buildStepStart = ()=>{
        return(
            <>
                <div className={styles.st0Cont}>
                    {false &&
                        <>
                            <div className={styles.xIbit}>{initData}</div>
                            <div className={styles.xIbit}>{userInfo?.userId}</div>
                            <div className={styles.xIbit}>{userInfo?.referer}</div>
                        </>
                    }

                    <div className={styles.st0Robo}><img src={titleRobo} alt={"Робот"}/></div>
                    { cnt > 0 &&
                        <div className={styles.st0LineOne}>Привет, я сим бот</div>

                    }
                    { cnt > 1 &&

                        <div className={styles.st0LineTwo}>Я умею </div>

                    }


                    <div className={styles.st0Cont}>
                        {cnt > 2 &&
                            <div className={styles.st0BlockCont}>
                                <div><img src={st0Location} alt={"Кошелек"}/></div>
                                <div className={styles.st0BlockText}>Определить регион твоего номера</div>
                            </div>
                        }
                        {cnt > 3 &&
                            <div className={styles.st0BlockCont}>
                                <div><img src={st0Wallet} alt={"Позиция"}/></div>
                                <div className={styles.st0BlockText}>Снизить расходы на связь до 70%</div>
                            </div>

                        }
                        {cnt > 4 &&
                            <div className={styles.st0BlockCont}>
                                <div><img src={st0Sim} alt={"Сим"}/></div>
                                <div className={styles.st0BlockText}>Подбирать лучшие тарифы</div>
                            </div>

                        }

                    </div>

                    {
                        cnt > 5 &&
                        <div>
                            <div className={styles.st0Butt}
                                onClick={()=>setStep(10)}
                            >
                                НАЧАТЬ
                            </div>

                        </div>

                    }

                </div>
            </>
        )
    }


    const truncateString = (str: string, n: number)=> {
        if (!str || str?.length <= n) {
            return str; // Строка не превышает лимит, возвращаем её как есть
        }
        return str.slice(0, n - 1) + '…'; // Берем подстроку до n-1 символа и добавляем многоточие
    }


    const buildCardArray = ()=>{
        const x = cardList?.map((item,idx)=>{
            if(!Array.isArray(item?.apList) || !Array.isArray(item?.netList) || !Array.isArray(item?.packetList) ){
                return null
            }

            let operImage = lpMegafon
            let cssCard = styles.st2CardMegafon
            if(item?.operId?.match(/beeline/ui)){
                operImage = lpBeeline
                cssCard = styles.st2CardBeeline
            }
            if(item?.operId?.match(/tele2/ui)){
                operImage = lpTele2
                cssCard = styles.st2CardTele2
            }
            if(item?.operId?.match(/yota/ui)){
                operImage = lpYota
                cssCard = styles.st2CardYota
            }

            const netText = item?.netList[0]?.val?.match(/^9999$/ui) ? "Безлимит" : `${item?.netList[0]?.val} Гб.`
            const packetText = item?.packetList[0]?.val ? `${item?.packetList[0]?.val} минут` : `минут`
            const smsText = item?.smsCount !== undefined ? `${item?.smsCount} штук` : "0 штук"

            return(
                <div key={idx} className={["d-flex col-6"].join(' ')} onClick={()=>{
                    //if(refCoupon.current)refCoupon.current.scrollIntoView()
                    setShDetail(idx)
                    copyCoupon(false).catch()
                    //setTimeout(()=>setShDetail(-1), 2500)
                }}>
                    <div className={[styles.st2CardCont].join(' ')}>

                        {item?.needMnp &&
                            <div className={styles.mnpCont}>
                                <img src={mnp} alt={"смена оператора"}/>
                                <div className={styles.mnpText}>Смена оператора</div>
                            </div>
                        }

                        <div className={styles.st2OperLine}>
                            <div className={[styles.st2OperName].join(' ')}>{item?.operOne?.name}</div>
                            <div className={styles.operRound}>
                                <img src={operImage} alt={"оператор"}/>
                            </div>
                        </div>

                        <div className={styles.st2TarifAp}><span>{item?.apList[0]?.val}</span>Р/мес</div>

                        <div className={styles.st2NetLine}>
                            <div><img src={phone}/></div>
                            <div className={styles.st2NetText}>{packetText}</div>
                        </div>

                        <div className={styles.st2NetLine}>
                            <div><img src={net}/></div>
                            <div className={styles.st2NetText}>{netText}</div>
                        </div>

                        <div className={styles.st2NetLine}>
                            <div><img src={sms}/></div>
                            <div className={styles.st2NetText}>{smsText}</div>
                        </div>
                        {shDetail === idx &&
                            <div className={styles.cpInCIntX}>
                                <div className={styles.inCont}>
                                    Для детальной информации и подключению, нажмите кнопку «подключить», не забываем про купон
                                </div>
                            </div>

                        }



                    </div>
                </div>
            )

        })
        return(
            <>
                <div className={["row g-0"].join(' ')}>
                    <div className={["col-12", styles.cdResText].join(' ')}>
                        <div className={styles.cdPlane}>Тарифы для номера {ctn}</div>
                    </div>

                </div>
                <div className={["row g-0"].join(' ')}>{x}</div>
            </>
        )
    }




    const buildStepResult = ()=>{
        return(
            <div className={[styles.st2Cont,styles.showSlow].join(' ')}>
                <div>
                    {buildCardArray()}
                </div>

                <div className={styles.cpItem} ref={refCoupon}>
                    <div className={styles.cpTextCont}>
                        <div className={styles.cpTitle}>Для подключения используйте купон на скиду</div>
                        <div className={styles.cpText}>{couponId}</div>
                        <div className={styles.cpCont} onClick={()=>copyCoupon().catch()}>
                            <img src={copyImg} alt={"Копировать"}/>
                            <div>Копировать</div>
                            {shCopyBuffer &&
                                <div className={styles.cpCopyText}>купон скопирован в буфер</div>

                            }
                        </div>


                    </div>


                    <img src={cpBack} alt={"Фон"}/>
                </div>


                <div className={styles.btConnectCont}>
                    <Link to={link} className={styles.conLink} target={"_blank"}>
                        <div className={styles.btConnect}
                        >ПОДКЛЮЧИТЬ</div>

                    </Link>
                </div>
                <div className={styles.btConnectCont}>
                    <div className={styles.btAgain}
                        onClick={()=>setStep(10)}
                    >попробовать заново</div>
                </div>

            </div>
        )
    }


    const buildStepFind = ()=>{
        return(
            <>
                <div className={styles.fsCont}>
                    <div className={styles.fsTextBlock}>
                        <div className={styles.fsText1}>Ищем самый выгодный тариф...</div>
                        <div className={styles.fsText2}>Анализируем предложения операторов</div>
                    </div>
                    <div className={styles.ldCont}>
                        <div className={styles.loader}>
                            <div className={styles.fsRobo}>
                                <img src={robo} alt={"робот"}/>
                            </div>
                        </div>
                    </div>

                    <div className={styles.xLoaderCont}>
                        <div className={styles.xLoader}>
                            <div className={styles.xLoaderLine} style={{width:`${percent > 99 ? 99 : percent}%`}}></div>

                        </div>
                        <div className={styles.xLoaderText}>Пожалуйста, подождите, это займет немного времени</div>
                    </div>


                </div>
            </>
        )
    }


    return(

        <div className={styles.botCont}>
            <div className={styles.mainCont}>
                {step === 0 &&
                    buildStepStart()
                }
                {step === 10 &&
                    buildStepInData()
                }
                {step === 15 &&
                    buildStepFind()
                }


                {step === 20 &&
                    buildStepResult()
                }

            </div>

        </div>
    )
}